export interface StoreStyle {
  label: string;
  bg: string;
  color: string;
}

const STORE_MAP: Record<string, StoreStyle> = {
  'sixhats': { label: 'CA', bg: '#D80621', color: '#FFFFFF' },
  'sixhatssupply': { label: 'US', bg: '#002868', color: '#FFFFFF' },
};

const DEFAULT_STORE: StoreStyle = STORE_MAP['sixhats'];

export function getStoreLabel(shopDomain?: string): StoreStyle {
  if (!shopDomain) return DEFAULT_STORE;
  const entry: StoreStyle | undefined = Object.prototype.hasOwnProperty.call(STORE_MAP, shopDomain)
    ? STORE_MAP[shopDomain]
    : undefined;
  return entry || { label: shopDomain.toUpperCase(), bg: '#E4E5E7', color: '#303030' };
}

const CURRENCY_TO_DOMAIN: Record<string, string> = {
  'CAD': 'sixhats',
  'USD': 'sixhatssupply',
};

export function getDraftOrderNameColor(shopDomain?: string): string | undefined {
  if (!shopDomain) return undefined;
  const store = STORE_MAP[shopDomain];
  return store?.bg;
}

export function StoreBadge({ shopDomain, currency }: { shopDomain?: string; currency?: string }) {
  const domain = shopDomain || (currency ? CURRENCY_TO_DOMAIN[currency] : undefined);
  const store = getStoreLabel(domain);
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: '10px',
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '16px',
      backgroundColor: store.bg,
      color: store.color,
    }}>
      {store.label}
    </span>
  );
}
